import { AnimatePresence, motion } from 'framer-motion';

import {
    IBlockViewModel,
    IProductItemViewModel,
    IProductListCreativeItem,
    IWishListTranslations,
} from 'Types/Litium';
import { ISrcSetSize } from 'Types/shared';
import BlockRenderer from 'Blocks/BlockRenderer';
import ProductCard from 'Components/ProductCard/ProductCard';

import ProductListCreativeItem from './ProductListCreativeItem';

const ProductList = ({
    products,
    quickBuyProduct,
    columns = 5,
    additionalTranslations,
    srcSetSizes = {
        default: { width: 156, height: 222 },
        md: { width: 356, height: 507 },
        lg: { width: 166, height: 238 },
        xl: { width: 250, height: 357 },
        xxl: { width: 368, height: 525 },
    },
    blockAreas,
    productListCreativeItems,
}: {
    products: IProductItemViewModel[];
    columns?: number;
    srcSetSizes?: ISrcSetSize;
    quickBuyProduct?: boolean;
    additionalTranslations?: IWishListTranslations;
    blockAreas?: { [key: string]: IBlockViewModel[] };
    productListCreativeItems: IProductListCreativeItem[];
}) => (
    <ul
        style={{ '--columns': columns } as React.CSSProperties}
        className={`grid ${
            quickBuyProduct ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-2'
        } gap-5 lg:grid-cols-[repeat(var(--columns),_minmax(0,_1fr))] supports-[grid-template-rows:_subgrid]:lg:grid-rows-[auto]`}
    >
        <AnimatePresence mode="popLayout">
            {products?.map((product, index) => (
                <>
                    {index === 10 && blockAreas?.third?.length > 0 && (
                        <li
                            key="block-area-third"
                            className={`${
                                quickBuyProduct
                                    ? 'col-span-1 md:col-span-2'
                                    : 'col-span-2'
                            } lg:col-span-5`}
                        >
                            <BlockRenderer blocks={blockAreas.third} />
                        </li>
                    )}

                    {productListCreativeItems &&
                        productListCreativeItems.find(
                            x => x.index === index && x.image.src
                        ) && (
                            <li
                                key={`creative-list-item-${index}`}
                                className="col-span-2 flex gap-3 supports-[grid-template-rows:_subgrid]:row-[span_2] supports-[grid-template-rows:_subgrid]:grid supports-[grid-template-rows:_subgrid]:grid-rows-subgrid"
                            >
                                <ProductListCreativeItem
                                    item={productListCreativeItems.find(
                                        x => x.index === index
                                    )}
                                />
                            </li>
                        )}

                    <motion.li
                        layout
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }}
                        transition={{ type: 'spring', bounce: 0.25 }}
                        key={`${product.id}-${index}`}
                        className="flex gap-3 supports-[grid-template-rows:_subgrid]:row-[span_2] supports-[grid-template-rows:_subgrid]:grid supports-[grid-template-rows:_subgrid]:grid-rows-subgrid"
                    >
                        <ProductCard
                            showQuantityField={product.showQuantityField}
                            id={product.id}
                            productFilters={product.productFilters}
                            quickBuyProduct={quickBuyProduct}
                            isPurchasable={product.isPurchasable}
                            isOnWishList={product.isOnWishList}
                            enabledWishlist={product.enabledWishlist}
                            images={product.images}
                            name={product.name}
                            colors={product.productFilters.colors}
                            sizes={product.productFilters.sizes}
                            url={product.url}
                            videoUrl={product.videoUrl}
                            translations={product.translations}
                            lazy={index > 3}
                            srcSetSizes={srcSetSizes}
                            subgrid
                            productTag={product.productTag}
                            priceVM={product.priceVM}
                            hasAnyVariantEnabled={product.hasAnyVariantEnabled}
                            values={product.productFilters.values}
                            additionalTranslations={additionalTranslations}
                            trackingData={product.trackingData}
                            descriptiveVariantName={
                                product.descriptiveVariantName
                            }
                            isGiftCard={product.isGiftCard}
                        />
                    </motion.li>
                </>
            ))}
        </AnimatePresence>
    </ul>
);

export default ProductList;
